import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Tooltip } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

import p13nService from "@plannel/services/system/p13n-service";
import debug from "@plannel/utils/debug-util";

/*
 * 대시보드 → 홈 "고정한 대시보드" 즐겨찾기 토글(별).
 *   저장: z_p13n pageCd "PINNED_DASHBOARD", configObj = { dashboards: [reduxKey(viewName), ...] }
 *   워크플로우 즐겨찾기(MY_WORKFLOW)와 동일한 개인화 패턴. 홈 PinnedCard 가 이 목록을 읽어 노출.
 * DashboardTopBar 의 pinViewName prop 으로 자동 배치되며, 어떤 페이지든 <PinDashboardButton viewName=.. /> 로 쓸 수 있다.
 */
export const PINNED_PAGE_CD = "PINNED_DASHBOARD";

const PinDashboardButton = ({ viewName }) => {
  const { t } = useTranslation();
  const [pinned, setPinned] = useState(false);

  useEffect(() => {
    let alive = true;
    p13nService.get(PINNED_PAGE_CD)
      .then((res) => { if (alive) setPinned((res?.data?.dashboards ?? []).includes(viewName)); })
      .catch((e) => debug(e));
    return () => { alive = false; };
  }, [viewName]);

  const toggle = () => {
    // 낙관적 반영 후 저장 — 최신 목록을 다시 읽어 다른 대시보드에서의 변경과 충돌하지 않게 한다.
    p13nService.get(PINNED_PAGE_CD)
      .then((res) => {
        const list = res?.data?.dashboards ?? [];
        const next = list.includes(viewName) ? list.filter((v) => v !== viewName) : [...list, viewName];
        setPinned(next.includes(viewName));
        return p13nService.upsert({ pageCd: PINNED_PAGE_CD, configObj: { dashboards: next } });
      })
      .catch((e) => debug(e));
  };

  return (
    <Tooltip title={pinned ? t("unpinFromHome", "홈에서 제거") : t("pinToHome", "홈에 고정")}>
      <IconButton size="small" onClick={toggle} sx={{ p: 0.4 }} aria-label="pin dashboard to home">
        {pinned
          ? <StarIcon sx={{ fontSize: 17, color: "#F5B300" }} />
          : <StarBorderIcon sx={{ fontSize: 17, color: "text.secondary" }} />}
      </IconButton>
    </Tooltip>
  );
};

export default PinDashboardButton;
